const creditCardIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12.3333C3 8.87658 3 7.14775 4.07433 6.07433C5.14775 5 6.87658 5 10.3333 5H14C17.4568 5 19.1856 5 20.259 6.07433C21.3333 7.14775 21.3333 8.87658 21.3333 12.3333C21.3333 15.7901 21.3333 17.5189 20.259 18.5923C19.1856 19.6667 17.4568 19.6667 14 19.6667H10.3333C6.87658 19.6667 5.14775 19.6667 4.07433 18.5923C3 17.5189 3 15.7901 3 12.3333Z" stroke="#353333" stroke-width="1.5"/>
<path d="M10.3333 16H6.66667M14 16H12.625M3 10.5H21.3333" stroke="#353333" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`

export default creditCardIcon
